var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06597 0.195395C4.94631 0.0702835 4.78404 0 4.61485 0C4.44565 0 4.28338 0.0702835 4.16372 0.195395L0.97332 3.5322C0.853699 3.65735 0.786499 3.82707 0.786499 4.00403C0.786499 4.18099 0.853699 4.3507 0.97332 4.47585L4.16372 7.81266C4.28407 7.93423 4.44525 8.00149 4.61255 7.99997C4.77985 7.99845 4.93989 7.92827 5.0582 7.80453C5.1765 7.6808 5.24361 7.51342 5.24506 7.33844C5.24652 7.16346 5.1822 6.99488 5.06597 6.86901L2.32669 4.00403L5.06597 1.13904C5.18559 1.0139 5.25279 0.84418 5.25279 0.667219C5.25279 0.490259 5.18559 0.320543 5.06597 0.195395Z",
    fill: "#2871F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.e5c87f55.svg";
export { ForwardRef as ReactComponent };